import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { LabelNames, ApplicationConfiguration, FooterLink, Member } from '../../shared/core/ovs.core';
import { ResortDetail, ResortGuest } from '../../models/presentation.model';
import { DisplayValue } from '../../models/browser.model';
import { ResortComponent } from '../../shared/resort.component';
import { Animations } from '../../shared/animations/animations';
import * as moment from 'moment';
import { CheckoutPageEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
    selector: 'guest',
    templateUrl: './guest.component.html',
    styleUrls: ['./guest.component.scss'],
    animations: [Animations.slideInOut],
    encapsulation: ViewEncapsulation.None,
})
export class GuestComponent extends ResortComponent {
    @Input() public guest: ResortGuest;
    @Input() public resort: ResortDetail;
    @Input() public members: Member[] = [];
    @Input() public numberOfGuests: number;
    @Input() public isFormInvalid: boolean;
    @Input() public configuration: ApplicationConfiguration;

    @Output() public guestIsPurchaserChecked: EventEmitter<any> = new EventEmitter();
    @Output() public guestMemberChanged: EventEmitter<any> = new EventEmitter();
    @Output() public dateOfBirthChanged: EventEmitter<any> = new EventEmitter();
    @Output() public guestRemoved: EventEmitter<any> = new EventEmitter();

    public months: DisplayValue<number>[];
    public years: DisplayValue<number>[];
    public days: DisplayValue<number>[] = [];
    public guestIsPurchaserCurrentValue: boolean;
    public selectedGuest: Member;
    public showHide: boolean;
    public marketingMsg: string;
    public footerLinks: FooterLink[];
    public privacyPolicyUrl: string;
    public termsConditionsUrl: string;
    public marketingOptIn: boolean = true;
    private guestNameChanged: Boolean = false;

    public initialize(): void {
        super.initialize();
        this.guest.IsTextMessagingApproved = true;

        if (this.configuration.Labels.length != 0) {
            this.marketingMsg = this.configuration.Labels ? this.configuration.Labels.first(l => l.Name == LabelNames.MarketingOptInLabel).DisplayText : `I consent to receive autodialed and/or pre-recorded telemarketing calls and text messages at the telephone numbers provided concerning products and services offered by or on behalf of ${this.configuration.Partner.LongName}. I understand that consent is not required to make any purchase of goods or services from ${this.configuration.Partner.LongName} and my consent may be revoked at any time. Message and data rates may apply.`;
            this.marketingMsg = this.marketingMsg.replace(new RegExp('{{ configuration.Partner.LongName }}', 'g'), this.configuration.Partner.LongName);
        }

        this.footerLinks = this.configuration.FooterLinks;
        const legalLinks = [];

        this.footerLinks.forEach((link) => {
            if (
                (link.DisplayText.toLowerCase() === "privacy policy") ||
                (link.DisplayText.toLowerCase() === "terms & conditions") ||
                (link.DisplayText.toLowerCase() === "terms and conditions")
            ) {
                legalLinks.push(link);
            }
        })

        if (legalLinks.length) {
            this.termsConditionsUrl = legalLinks[1] && legalLinks[1].NavigationUrl;
            this.privacyPolicyUrl = legalLinks[0] && legalLinks[0].NavigationUrl;
        }

        let months: DisplayValue<number>[] = [];
        for (let index: number = 0; index < 12; index++) {
            months.add(new DisplayValue(index + 1, moment(new Date(1900, index)).format("MM")));
        }
        this.months = months;

        let years: DisplayValue<number>[] = [];
        for (let index: number = new Date().getFullYear(); index > new Date().getFullYear() - 120; index--) {
            years.add(new DisplayValue(index, index.toString()));
        }
        this.years = years;

        if (this.guest.index == 0) {
            this.selectedGuest = this.members.where(g => g.LastName == this.guest.LastName && g.FirstName == this.guest.FirstName).firstOrDefault();
        }
    }

    public onGuestMemberChanged(guest: ResortGuest, member: Member): void {
        guest.FirstName = member.FirstName;
        guest.LastName = member.LastName;

        if (this.guest.index === 0) { //first guest
            UserActivityLogger.logEvent(CheckoutPageEvents.FirstGuestDropDownSelectionMade, {}, UserActivityLoggerOptions.AppInsightsOnly);
            this.guestIsPurchaserChecked.emit(this.guestIsPurchaserCurrentValue);
            this.guestMemberChanged.emit(guest);
        }
    }

    public onGuestFirstNameChanged(firstName: string) {
        this.guestNameChanged = this.guest.index === 0;
        this.guestMemberChanged.emit(this.guest);
    }

    public onGuestLastNameChanged(lastName: string) {
        this.guestNameChanged = this.guest.index === 0;
        this.guestMemberChanged.emit(this.guest);
    }

    public onNameBlur() {
        if (this.guestNameChanged) {
            UserActivityLogger.logEvent(CheckoutPageEvents.FirstGuestNameUpdated, {}, UserActivityLoggerOptions.AppInsightsOnly);
            this.guestNameChanged = false;
        }
    }

    public onMonthChanged(month: number): void {
        let daysInMonth: number = 32 - new Date(this.guest.DobYear ? this.guest.DobYear : 2016, month - 1, 32).getDate();

        let days: DisplayValue<number>[] = [];
        for (let index: number = 1; index <= daysInMonth; index++) {
            days.add(new DisplayValue(index, index.toString()));
        }
        this.days = days;
        this.RaiseDateOfBirthChanged();
    }

    public onYearChanged(year: number): void {
        let daysInMonth: number = 32 - new Date(year ? year : 2016, this.guest.DobMonth - 1, 32).getDate();

        let days: DisplayValue<number>[] = [];
        for (let index: number = 1; index <= daysInMonth; index++) {
            days.add(new DisplayValue(index, index.toString()));
        }
        this.days = days;
        this.RaiseDateOfBirthChanged();
    }

    public onDayChanged(day: number): void {
        this.RaiseDateOfBirthChanged();
    }

    public RaiseDateOfBirthChanged(): void {
        if (this.guest.DobDay > 0 && this.guest.DobMonth > 0 && this.guest.DobYear > 0)
            this.dateOfBirthChanged.emit(this.guest);
    }

    public onGuestIsPurchaser(value: any): void {
        this.guestIsPurchaserCurrentValue = value;
        this.guestIsPurchaserChecked.emit(value);
    }

    public onOptIn(value: any): void {
        this.guest.IsTextMessagingApproved = value;
    }

    public removeGuest(): void {
        this.guestRemoved.emit(this.guest.index);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/guest/guest.component.ts